import styled from "ibis-design-system/lib/HelperFunctions/ThirdParty/styled-components";
import {IFoundation} from "../Interfaces/IFoundation";

export const GreyBox = styled.div`
  background-color: ${(props: IFoundation) => props.theme.colors.neutralLight};
  padding: 10px;
  position: relative;
`